import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { Router } from '@angular/router';
import { Client } from '../../../models';
import { DataService, WorkflowContextService } from '../../../services';
import { finalize } from 'rxjs';

@Component({
  selector: 'wm-client-list',
  templateUrl: './client-list.component.html',
  styleUrls: ['./client-list.component.css'],
  standalone: false
})
export class ClientListComponent implements OnInit, OnChanges {
  @Input() clients: Client[];

  groupedClients: { state: string; clients: Client[] }[];
  departmentId: string
  // added by ketan 16-01-2026
  // ------------------------
  noDepartmentModalOpen: boolean
  isFetchingDepartment: boolean
  // ---------------------
  // ended by ketan 16-01-2026

  constructor(
    private _context: WorkflowContextService,
    private _router: Router,
    private dataService: DataService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    this.groupClientsByState();
  }

  private sort(a: Client, b: Client) {
    if (a.name > b.name) {
      return 1;
    } else if (a.name < b.name) {
      return -1;
    } else {
      return 0;
    }
  }

  private buildStates(clients: Client[]): string[] {
    // get unique list of states for clients;
    const states: string[] = [];

    if (clients) {
      for (const client of clients) {
        if (!states.includes(client.state)) {
          states.push(client.state);
        }
      }
    }

    // Initialize variables
    return states.sort();
  }

  groupClientsByState() {
    this.groupedClients = this.buildStates(this.clients).map(state => ({
      state,
      clients: this.clients
        .filter(client => client.state === state)
        .sort(this.sort)
    }));
  }


  onClientClick(client: Client): void {

    // update layout context
    //this._context.useNewLayout$.next(client.useNewLayout !== false);


    if (false) {
      this.isFetchingDepartment = true
      this.dataService.getClientDepartments(client.id).pipe(finalize(() => {
        this.isFetchingDepartment = false
      })).
        subscribe({
          next: (response) => {
            if (response.length === 0) {
              this.noDepartmentModalOpen = true;
              this._context.staffDepartmentId$.emit(null);
              return
            }
            // after fetching departments based on client id initally set first department
            const firstDept = response?.[0]
            const departmentId = firstDept.id;
            this._context.staffDepartmentId$.emit(firstDept.id);

            this._router.navigate([
              '/admin/jurisdiction',
              client.id,
              'department',
              departmentId
            ], { state: {useNewLayout: client.useNewLayout} });
          },
          error: () => {
this._context.staffDepartmentId$.emit(null);
            this.noDepartmentModalOpen = true;
          }
        });
    } else {
      this._context.staffDepartmentId$.emit(null);
      this._router.navigate([
        '/admin/jurisdiction',
        client.id,
        'workflows'
      ]);

    }
  }


  ngOnInit() {
    this.groupClientsByState();
  }
  closeNoDepartmentModal() {
    this._router.navigate([
        '/admin/jurisdiction',
        this._context.client.id,
        'workflows'
      ]);
    this.noDepartmentModalOpen = false;
  }
}
